import { isNil } from 'lodash';
// Import Helpers
import { customMomentWithoutTimezoneConversion } from 'services/Helpers';

export const formatDateTime = (date, formatType) => {
    return isNil(date) ? '' : customMomentWithoutTimezoneConversion(date).format(formatType);
};
